import { render, staticRenderFns } from "./ActionCenterWrapper.vue?vue&type=template&id=1431f189&"
import script from "./ActionCenterWrapper.vue?vue&type=script&lang=js&"
export * from "./ActionCenterWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports